<template>
  <div class="box-Privacy has-text-left th is-size-6">
    <p
      class="has-text-centered pd-b-20 text-level-company font-24 has-text-weight-normal"
    >
      Privacy Policy
    </p>

    <p class="has-text-centered font-20">
      Protecting privacy and personal data is of utmost importance to inteGreat.
    </p>
    <p class="pd-t-15">
      &emsp;&emsp;&emsp;&emsp;This policy has been prepared by LFFINTECH Co.,
      Ltd. and Thai Business Incubators and Science Parks Association:
      Thai-BISPA in order to provide an understanding of our practices in
      managing the personal information of all users who contact the
      integreat.in.th website or sign up for inteGreat's services. For your
      benefit and understanding of the services we provide, we kindly ask you to
      read and thoroughly comprehend this document.
    </p>
    <p class="pd-t-15">
      &emsp;&emsp;&emsp;&emsp;Furthermore, any communication or registration for
      the use of inteGreat's website or services shall be deemed as your consent
      to be bound by this policy in all respects.
    </p>
    <p class="pd-t-15">
      &emsp;&emsp;&emsp;&emsp;Any definitions appearing in this privacy
      protection policy shall be interpreted in accordance with the terms
      specified in the InteGreat Terms of Service.
    </p>

    <p class="pd-t-15 has-text-weight-normal">1. Collection of Personal Data</p>
    <p>
      inteGreat provides software services of international standards that
      assist business owners and accounting consultants in conveniently and
      efficiently accessing financial and accounting information. In order to
      facilitate the provision of these services, it is necessary for inteGreat
      to collect and gather personal data, such as names, occupations, national
      identification numbers, addresses, workplace details, postal codes,
      telephone numbers, contact person emails, business registration
      information, and other relevant data.
    </p>

    <p class="pd-t-15 has-text-weight-normal">
      2. inteGreat will collect your personal data when:
    </p>
    <p class="pd-t-15">2.1 You register for the service.</p>
    <p class="pd-t-15">2.2 You use the service.</p>
    <p class="pd-t-15">
      2.3 You contact the support team for assistance in using the service.
    </p>
    <p class="pd-t-15">
      2.4 You visit the website. You have the right to withhold your personal
      data from inteGreat, but by doing so, you may not be able to utilize any
      services provided by inteGreat.
    </p>

    <p class="pd-t-15 has-text-weight-normal">
      3. Consent to the Use of Your Personal Data
    </p>
    <p class="pd-t-15">
      3.1 When you register for any services provided by inteGreat, it is
      considered that you consent to inteGreat collecting and using your data
      for the purposes specified in the Terms of Service and the Privacy
      Protection Policy.
    </p>
    <p class="pd-t-15">
      3.2 inteGreat will use your personal data for the following purposes:
    </p>
    <p>• To identify you as a user.</p>
    <p>• For the benefit of providing the services.</p>
    <p>
      • For communication regarding the services or any changes in the services.
    </p>
    <p>
      • For marketing purposes or related training activities associated with
      the services.
    </p>
    <p>
      • To provide assistance and troubleshoot technical or service-related
      issues.
    </p>
    <p>• To comply with legal requirements.</p>
    <p>• To communicate with you.</p>

    <p class="pd-t-15 has-text-weight-normal">
      4. Your Responsibilities in Password Care and Maintenance
    </p>
    <p>
      In order for inteGreat to successfully achieve its objectives in
      safeguarding your personal data, it is your responsibility to keep your
      password confidential. You are also responsible for promptly notifying
      inteGreat if you discover or become aware of any unauthorized use of your
      password.
    </p>

    <p class="pd-t-15 has-text-weight-normal">
      5. Collection of Personal Data from External Individuals
    </p>
    <p>
      In the event that you provide inteGreat with information relating to
      external individuals, you warrant that you have the rights or explicit
      permission from the data owner to do so, and you authorize inteGreat to
      store, use, and process such data within the limits defined in this
      privacy policy. It is your responsibility to inform the aforementioned
      external individuals about such actions and inteGreat's privacy policy.
      inteGreat bears no responsibility towards external individuals and has no
      obligation to notify them of such actions.
    </p>

    <p class="pd-t-15 has-text-weight-normal">
      6. Disclosure of Personal Information
    </p>
    <p>
      Your privacy and personal data are of utmost importance to inteGreat.
      inteGreat will not disclose your confidential information or personal data
      to any external individuals or organizations unless:
    </p>
    <p>• It has obtained your consent or complied with your request.</p>
    <p>
      • It is required by applicable laws, such as court orders or legal
      obligations.
    </p>
    <p>
      • It is necessary for the registration of government projects, including
      the name of the company, tax identification number, main contact person,
      email used for project registration, and the top executives of your
      organization. This also includes the name of the projects you participate
      in, both in Thai and English, for the purpose of registration in other
      government projects and checking for duplicates.
    </p>

    <p class="pd-t-15 has-text-weight-normal">
      7. Collection and Use of Non-Personal Information
    </p>
    <p>
      By using inteGreat's services, you authorize inteGreat to access and use
      your non-personal information for the following purposes:
    </p>
    <p>• To help us understand how you use our services.</p>
    <p>
      • To provide additional information to users about service usage and
      benefits.
    </p>
    <p>
      • To assist in supporting and improving the efficiency and effectiveness
      of small-scale businesses.
    </p>

    <p class="pd-t-15 has-text-weight-normal">
      8. Storing Your Data in the Cloud Database System
    </p>
    <p>
      inteGreat utilizes the services of Cloud, a leading provider of
      world-class database systems, which adheres to the ISO 27001:2013 security
      standards. By subscribing to inteGreat's services, you acknowledge and
      accept that your data will be stored in a standardized and secure Cloud
      database system for the purpose of preserving personal and other
      user-related information.
    </p>

    <p class="pd-t-15 has-text-weight-normal">
      9. Personal Data Protection Standards
    </p>
    <p>
      inteGreat maintains strict security standards to safeguard your personal
      data, ensuring protection against unauthorized access or damage. By
      utilizing a globally standardized Cloud database system with data security
      measures such as SSL encryption and firewalls, inteGreat ensures the
      secure transmission of data between the website and the database system.
    </p>

    <p class="pd-t-15 has-text-weight-normal">10. integreat's Use of Cookies</p>
    <p>
      “Cookies” are small computer files installed on your device to enhance the
      convenience of your website browsing experience. Cookies do not identify
      or contain any personally identifiable information but are used to
      identify your computer. By using cookies, inteGreat provides users with a
      more convenient experience on their website by remembering user
      preferences and usage patterns. Additionally, inteGreat may utilize the
      information stored in cookies for statistical analysis or other website
      improvement activities to enhance the quality of their services. You have
      the right to reject the use of cookies. However, please note that by doing
      so, you may not be able to fully utilize certain functions or features on
      inteGreat's website.
    </p>

    <p class="pd-t-15 has-text-weight-normal">
      11. Rights to Control Personal Data
    </p>
    <p>
      For privacy protection purposes, you have the right to choose whether to
      allow the use or sharing of your personal data or to opt-out of receiving
      any marketing materials from the website. You can indicate your
      preferences through the various channels provided on inteGreat's website.
    </p>

    <p class="pd-t-15 has-text-weight-normal">
      12. Complaints Regarding Privacy Matters
    </p>
    <p>
      If you have any problems, questions, suggestions, or feedback related to
      the privacy policy or its implementation, inteGreat is pleased to address
      your concerns and consider your suggestions or comments. This will be
      beneficial for future service improvements. You can contact inteGreat
      through the channels specified on their website.
    </p>

    <p class="pd-t-15 has-text-weight-normal">
      13. This Privacy Policy is Subject to the Terms of Service
    </p>
    <p>
      The limitations or exclusions of inteGreat's liability specified in the
      Terms of Service shall also apply to this
      <a href="/terms-of-use/startup" target="_blank" class="text-level-company"
        >privacy policy.</a
      >
    </p>

    <p class="pd-t-15">
      14. inteGreat Reserves the Right to Amend or Modify the Privacy Policy
      inteGreat reserves the right to update or modify the privacy policy
      without prior notice to ensure suitability and effectiveness in service
      delivery. Therefore, it is advisable for users to review the privacy
      policy whenever visiting or utilizing inteGreat's website.
    </p>
  </div>
</template>
<script>
export default {
  props: {
    rule: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.box-Privacy {
  padding: 40px;
  line-height: 30px;
  background-color: #ffffff;
  color: #363636;
}
p {
  text-align: justify;
}
</style>

